import { render, staticRenderFns } from "./FilterBtn.vue?vue&type=template&id=3c8e0d66&scoped=true"
import script from "./FilterBtn.vue?vue&type=script&lang=js"
export * from "./FilterBtn.vue?vue&type=script&lang=js"
import style0 from "./FilterBtn.vue?vue&type=style&index=0&id=3c8e0d66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8e0d66",
  null
  
)

export default component.exports